// UserContext.js
import React, { createContext, useState } from "react";
import api, { isAuthRejected } from "../utils/api";
import { turnOffPushOnSignOut } from "../pwa/pushSignOut";

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);

  const fetchUserData = async () => {
    const token = localStorage.getItem("authToken");
    if (token) {
      try {
        const response = await api.get("/auth/user/", {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (response.status === 200) {
          setUser(response.data);
          setIsAuthenticated(true);
        }
      } catch (error) {
        console.error("Error fetching user info:", error);
        if (isAuthRejected(error)) {
          localStorage.removeItem("authToken");
          localStorage.removeItem("refreshToken");
          setIsAuthenticated(false);
          setUser(null);
        }
      }
    }
  };

  const handleLogout = () => {
    // Notifications stop on this phone (shared phones); needs the token, so it goes first
    turnOffPushOnSignOut();
    localStorage.removeItem("authToken");
    localStorage.removeItem("refreshToken");
    setIsAuthenticated(false);
    setUser(null);
  };

  return (
    <UserContext.Provider
      value={{
        isAuthenticated,
        user,
        setIsAuthenticated,
        fetchUserData,
        handleLogout,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};
